import scrollMonitor from 'scrollmonitor';
import Sticky from 'sticky-js';

'use strict';

export default class Sidebar {
    constructor() { }

    stick() {
        const self = this;
        const section = document.querySelectorAll('section h2');

        for (let i = 0, l = section.length; i < l; i++) {
            let el = section[i];
            let sectionWatcher = scrollMonitor.create(el);

            sectionWatcher.enterViewport(function () {
                if (this.isInViewport) {
                    self.toggleActiveSection(el);
                }
            });

            sectionWatcher.exitViewport(function () { });
        }

        scrollMonitor.recalculateLocations();

        $('.-js-scroll-to').on('click', function (e) {
            e.preventDefault();

            const $this = $(this);
            const $href = $this.attr('href');

            $('html, body').animate({ scrollTop: $($href).offset().top }, {
                duration: 1000,
                easing: 'easeOutExpo'
            });
        });

        new Sticky('.sidebar__sticky');

        $('.sidebar__sections').css({ height: $('.sidebar__sections').height() });
    }

    toggleActiveSection(el) {
        const sidebar = $('.sidebar__sections');

        sidebar.find('.-active').removeClass('-active');
        sidebar.find('li:nth-child(' + ($(el).parent().index() + 1) + ')').addClass('-active');
    }
}
